import { NumberInput, Field } from '../UI';
import SectionCard from './SectionCard';
import RankingModeField from './RankingModeField';
import MatchScoringField from './MatchScoringField';

/**
 * Controlled-компонент настроек черновика.
 * Не хранит внутреннего состояния и не сохраняет сам — это делает родитель.
 */
const DraftSettings = ({
  courtsCount,      onCourtsCountChange,
  matchScoring,     onMatchScoringChange,
  matchDurationMinutes, onMatchDurationChange,
  rankingMode,      onRankingModeChange,
  // Режим таблицы лидеров нельзя менять после первого сыгранного матча (см. бэкенд).
  rankingLocked = false,
  rankingLockedHint,
}) => {
  return (
    <SectionCard title="Настройки">
      <Field label="Количество кортов">
        <NumberInput
          min={1} max={20}
          value={courtsCount}
          onChange={e => onCourtsCountChange(e.target.value)}
        />
      </Field>

      <MatchScoringField
        matchScoring={matchScoring}
        onMatchScoringChange={onMatchScoringChange}
        matchDurationMinutes={matchDurationMinutes}
        onMatchDurationChange={onMatchDurationChange}
      />

      <RankingModeField
        value={rankingMode}
        onChange={onRankingModeChange}
        disabled={rankingLocked}
        lockedHint={rankingLockedHint}
      />
    </SectionCard>
  );
};

export default DraftSettings;
